const FAQsIcon = ({ viewBox = "0 0 20 20", className = "hayley-h-[20px] hayley-w-[20px] hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path
        d="M10 16.25C10.6904 16.25 11.25 15.6904 11.25 15C11.25 14.3096 10.6904 13.75 10 13.75C9.30964 13.75 8.75 14.3096 8.75 15C8.75 15.6904 9.30964 16.25 10 16.25Z"
        fill="currentColor"
      />
      <path
        d="M8.125 5.09641C9.31625 4.02141 11.8975 4.04016 12.4038 5.89016C13.0625 8.29266 10 8.30266 10 11.8752"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 0.625H2.5C1.46447 0.625 0.625 1.46447 0.625 2.5V17.5C0.625 18.5355 1.46447 19.375 2.5 19.375H17.5C18.5355 19.375 19.375 18.5355 19.375 17.5V2.5C19.375 1.46447 18.5355 0.625 17.5 0.625Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FAQsIcon;
